import { Component, Input } from '@angular/core';
import { Country } from '../../models/country.model';
import { CommonModule } from '@angular/common';
import { FilterAllPipe } from '../../pipes/filter-all.pipe';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ModalController } from '@ionic/angular';
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonButtons,
  IonIcon
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';

@Component({
  selector: 'app-country-selection-modal',
  templateUrl: './country-selection-modal.component.html',
  styleUrls: ['./country-selection-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule, FilterAllPipe, TranslatePipe,
    IonHeader, IonToolbar, IonTitle, IonContent, IonGrid,
    IonRow, IonCol, IonButton, IonButtons, IonIcon
  ]
})
export class CountrySelectionModalComponent {
  @Input() availableCountries: Country[] = [];
  @Input() selectedCountry: Country | null = null;

  constructor(private modalController: ModalController) {
    addIcons({ close });
  }

  closeCountryModal() {
    this.modalController.dismiss({
      selectedCountry: this.selectedCountry
    });
  }

  selectCountry(country: Country) {
    this.selectedCountry = country;
  }

  isCountrySelected(country: Country): boolean {
    return this.selectedCountry?.name === country.name;
  }
}